import messages from './memberMessagingCatalogue.json' with { type: 'json' };

export const memberMessagingCatalogueEn: Readonly<typeof messages> = messages;
